import { useRef } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";
import { scrollToSection } from "../lib/scroll";

const LINES = ["Deine Zeit.", "Deine Leute.", "Dein Spiel."];

export default function FinalCTA() {
  const ref = useRef(null);
  const textRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const inView = useInView(textRef, { once: true, margin: "-80px" });

  return (
    <section ref={ref} data-testid="final-cta" className="relative flex min-h-[85vh] items-center justify-center overflow-hidden">
      <motion.img
        src="/images/cta.jpg"
        alt="Queue zielt auf die weiße Kugel im Spotlight"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#120d0b]/65" />
      <div ref={textRef} className="relative z-10 px-6 text-center">
        <motion.p
          className="mb-8 text-xs uppercase tracking-[0.3em] text-[#c9a24a]"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          07 — Dein Abend
        </motion.p>
        <h2 className="font-display font-light leading-[1.02] text-[#f4ecdd]">
          {LINES.map((line, i) => (
            <span key={line} className="block overflow-hidden">
              <motion.span
                data-testid={`cta-line-${i}`}
                className={`block text-[11vw] md:text-7xl lg:text-8xl ${i === 2 ? "italic text-[#e3c988]" : ""}`}
                initial={{ y: "110%" }}
                animate={inView ? { y: "0%" } : {}}
                transition={{ duration: 1, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h2>
        <motion.button
          data-testid="final-cta-button"
          onClick={() => scrollToSection("angebot")}
          className="mt-12 bg-[#5c1a1f] px-10 py-4 text-sm uppercase tracking-[0.18em] text-[#f4ecdd] transition-colors duration-300 hover:bg-[#3c1013]"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Vintage Billard entdecken
        </motion.button>
      </div>
    </section>
  );
}
